import { lightTheme } from '../styles';
import { vDriveDeliveryStatus } from '../types';

export const vDriveStatuses = {
  [vDriveDeliveryStatus.pending_assign]: {
    name: 'Pending Assign',
    value: vDriveDeliveryStatus.pending_assign,
    color: lightTheme.yellow,
  },
  [vDriveDeliveryStatus.pending_merchant]: {
    name: 'Pending Merchant',
    value: vDriveDeliveryStatus.pending_merchant,
    color: lightTheme.yellow,
  },
  [vDriveDeliveryStatus.scheduled]: {
    name: 'Scheduled',
    value: vDriveDeliveryStatus.scheduled,
    color: lightTheme.lightGray,
  },
  [vDriveDeliveryStatus.runner_assigned]: {
    name: 'Runner Assigned',
    value: vDriveDeliveryStatus.runner_assigned,
    color: lightTheme.darkBlue,
  },
  [vDriveDeliveryStatus.en_route_pickup]: {
    name: 'En Route to Pickup',
    value: vDriveDeliveryStatus.en_route_pickup,
    color: lightTheme.darkBlue,
  },
  [vDriveDeliveryStatus.arrived_pickup]: {
    name: 'Arrived at Pickup',
    value: vDriveDeliveryStatus.arrived_pickup,
    color: lightTheme.darkBlue,
  },
  [vDriveDeliveryStatus.picked_up]: {
    name: 'Picked Up',
    value: vDriveDeliveryStatus.picked_up,
    color: lightTheme.darkBlue,
  },
  [vDriveDeliveryStatus.en_route_dropoff]: {
    name: 'En Route to Dropoff',
    value: vDriveDeliveryStatus.en_route_dropoff,
    color: lightTheme.darkBlue,
  },
  [vDriveDeliveryStatus.arrived_dropoff]: {
    name: 'Arrived at Dropoff',
    value: vDriveDeliveryStatus.arrived_dropoff,
    color: lightTheme.darkBlue,
  },
  [vDriveDeliveryStatus.completed]: {
    name: 'Completed',
    value: vDriveDeliveryStatus.completed,
    color: lightTheme.green,
  },
  [vDriveDeliveryStatus.cancelled]: {
    name: 'Cancelled',
    value: vDriveDeliveryStatus.cancelled,
    color: lightTheme.primary,
  },
  [vDriveDeliveryStatus.returned]: {
    name: 'Returned',
    value: vDriveDeliveryStatus.returned,
    color: lightTheme.orange,
  },
  [vDriveDeliveryStatus.unknown]: {
    name: 'Unknown',
    value: vDriveDeliveryStatus.unknown,
    color: lightTheme.lightGray,
  },
};

export const vDriveStatuses2 = {
  [vDriveDeliveryStatus.pending_assign]: {
    name: 'Pending Assign',
    value: vDriveDeliveryStatus.pending_assign,
    color: lightTheme.yellow,
  },
  // [vDriveDeliveryStatus.pending_merchant]: {
  //   name: 'Pending Merchant',
  //   value: vDriveDeliveryStatus.pending_merchant,
  //   color: lightTheme.yellow,
  // },
  // [vDriveDeliveryStatus.scheduled]: {
  //   name: 'Scheduled',
  //   value: vDriveDeliveryStatus.scheduled,
  //   color: lightTheme.lightGray,
  // },
  [vDriveDeliveryStatus.runner_assigned]: {
    name: 'Runner Assigned',
    value: vDriveDeliveryStatus.runner_assigned,
    color: lightTheme.darkBlue,
  },
  [vDriveDeliveryStatus.en_route_pickup]: {
    name: 'En Route to Pickup',
    value: vDriveDeliveryStatus.en_route_pickup,
    color: lightTheme.darkBlue,
  },
  [vDriveDeliveryStatus.arrived_pickup]: {
    name: 'Arrived at Pickup',
    value: vDriveDeliveryStatus.arrived_pickup,
    color: lightTheme.darkBlue,
  },
  // [vDriveDeliveryStatus.picked_up]: {
  //   name: 'Picked Up',
  //   value: vDriveDeliveryStatus.picked_up,
  //   color: lightTheme.darkBlue,
  // },
  [vDriveDeliveryStatus.en_route_dropoff]: {
    name: 'En Route to Dropoff',
    value: vDriveDeliveryStatus.en_route_dropoff,
    color: lightTheme.darkBlue,
  },
  // [vDriveDeliveryStatus.arrived_dropoff]: {
  //   name: 'Arrived at Dropoff',
  //   value: vDriveDeliveryStatus.arrived_dropoff,
  //   color: lightTheme.darkBlue,
  // },
  [vDriveDeliveryStatus.completed]: {
    name: 'Completed',
    value: vDriveDeliveryStatus.completed,
    color: lightTheme.green,
  },
  [vDriveDeliveryStatus.cancelled]: {
    name: 'Cancelled',
    value: vDriveDeliveryStatus.cancelled,
    color: lightTheme.primary,
  },
  // [vDriveDeliveryStatus.unknown]: {
  //   name: 'Unknown',
  //   value: vDriveDeliveryStatus.unknown,
  //   color: lightTheme.lightGray,
  // },
};
